import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState, useContext } from "react";
import { ListGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { useLocalisation } from "../features/localization/localisationSlice";
import { Lang } from "../sharedTypes";
import { useTranslation } from "react-i18next";
import { useUser } from "../features/user/userSlice";

const LoginButton = (props: {
  id?: string;
  flat?: boolean;
  icon?: boolean;
  className?: string;
  alternativelabel?: string;
}) => {
  let lang = "en" as Lang;
  const { isAuthenticated, isLoading, loginWithRedirect, logout } = useAuth0();
  const [showButton, setShowButton] = useState(false);
  const [_, getLabel] = useLocalisation();
  const { t, i18n } = useTranslation();
  const { logOut } = useUser();

  useEffect(() => {
    if (isLoading) {
      setShowButton(false);
    } else if (isLoading === false) {
      setShowButton(true);
    }
  }, [isLoading, isAuthenticated]);

  const setRedirectUrl = () => {
    window.localStorage.setItem("url", window.location.pathname);
  };

  return (
    <>
      {showButton && !props.flat && (
        <button
          className="navbar-btn"
          {...props}
          onClick={async () => {
            if (isAuthenticated) {
              await logOut();
              logout({ logoutParams: { returnTo: window.location.origin } });
            } else {
              setRedirectUrl();
              loginWithRedirect();
            }
          }}
        >
          {isAuthenticated
            ? t("general.log_out") + ""
            : props.alternativelabel
              ? getLabel(lang, props.alternativelabel)
              : t("general.sign_in") + ""}
        </button>
      )}
      {showButton && props.flat && (
        <ListGroup.Item
          className={`"navbar-btn-flat ${props.className}"`}
          id={props.id}
          onClick={() => {
            if (isAuthenticated) {
              logout();
            } else {
              setRedirectUrl();
              loginWithRedirect();
            }
          }}
        >
          {props.icon && <FontAwesomeIcon style={{ marginRight: 5 }} icon={faSignOutAlt} />}
          {isAuthenticated ? t("general.log_out") + "" : t("general.sign_in") + ""}
        </ListGroup.Item>
      )}
    </>
  );
};

export default LoginButton;
